export default "__VITE_ASSET__apzEf4WR__"